import * as api from "~/api";
import { PAYMENT } from "~/utils/urlApi";
import { createQueryString } from "~/utils/func";

export const apiRequestHealthInsuranceCard = (
  baseUrl,
  user = {},
  paymentID
) => {
  const data = new FormData();
  data.append("user_id", user.user_id);
  data.append("access_token", user.access_token);
  data.append("payment", paymentID);

  return api.postHttpRequestAsync(
    `${baseUrl}${PAYMENT.GET_INFO_BOOKING_API_REQUEST}`,
    data
  );
};

export const apiRequestAllPaymentMethod = (baseUrl, price) => {
  const url = createQueryString(
    `${baseUrl}${PAYMENT.GET_ALL_PAYMENT_METHOD_API_REQUEST}`,
    price
  );
  // const url = `${baseUrl}${PAYMENT.GET_ALL_PAYMENT_METHOD_API_REQUEST}`;
  return api.getHttpRequest(url);
};
